import { createSelector } from '@reduxjs/toolkit';
import { permissionsAdapter } from '../../slices/features/permissions.slice';
import { RootState } from '../../store';
import { getTenantSettings, getUser } from './common.selectors';
import { ApplicationPermissions } from '../../../components/Common';

export const {
    selectAll: getAllPermissions, selectById: getPermissionById, selectIds: getPermissionStrings,
} = permissionsAdapter.getSelectors<RootState>(state => state.permissions);

export const getUserHasSelfDispatchAccess = createSelector(
    getPermissionStrings,
    getTenantSettings,
    getUser,
    (permissions, tenantSettings, user) => {
        if (!tenantSettings?.enableSelfDispatchTimesheets) {
            return false;
        }

        if (user?.tenantId !== user?.companyTenantId) {
            return false;
        }

        return user?.employeeId && user.employeeId > 0 && permissions.includes(
            ApplicationPermissions.nonFlagging_timesheet_create,
        );
    },
);